document.addEventListener('DOMContentLoaded', () => {
// Select elements

  if (document.body.classList.contains('template-product')) {
  setTimeout(() => {
const thumbnails = document.querySelectorAll('.thumbnail-list.list-unstyled.slider li button');
const prevArrow = document.querySelector('.thumbnail-slider .slider-button.slider-button--prev');
const nextArrow = document.querySelector('.thumbnail-slider .slider-button.slider-button--next');

    prevArrow.removeAttribute('disabled');
  
    nextArrow.removeAttribute('disabled');
   


// Function to update the active thumbnail by aria-current
function updateActiveThumbnail(newIndex) {
  // Remove aria-current from the current thumbnail
  const currentActive = document.querySelector('.thumbnail-list.list-unstyled.slider li button[aria-current="true"]');
  if (currentActive) currentActive.removeAttribute('aria-current');

  // Add aria-current to the new thumbnail
  thumbnails[newIndex].setAttribute('aria-current', 'true');
}

// Event listener for previous arrow
prevArrow.addEventListener('click', () => {

  const currentIndex = [...thumbnails].findIndex(thumb => thumb.getAttribute('aria-current') === 'true');
  if (currentIndex === -1) {
    console.error('No active thumbnail found.');
    return;
  }

  const prevIndex = (currentIndex - 1 + thumbnails.length) % thumbnails.length; // Wrap around
  updateActiveThumbnail(prevIndex);

  // Simulate click on the new active thumbnail
  thumbnails[prevIndex].click();
});

// Event listener for next arrow
nextArrow.addEventListener('click', () => {

  const currentIndex = [...thumbnails].findIndex(thumb => thumb.getAttribute('aria-current') === 'true');
  if (currentIndex === -1) {
    console.error('No active thumbnail found.');
    return;
  }

  const nextIndex = (currentIndex + 1) % thumbnails.length; // Wrap around
  updateActiveThumbnail(nextIndex);

  // Simulate click on the new active thumbnail
  thumbnails[nextIndex].click();
});


    }, 1500);

  }


  

    // Get the current URL parameters
    var urlParams = new URLSearchParams(window.location.search);
    
    // Check if the 'page' parameter is 2 or higher
    var page = parseInt(urlParams.get('page'));
    if (page >= 2) {
        // Add the new class to elements with the 'cstm_coll_list' class
        $('.cstm_coll_list').addClass('new-class');
    }


if (document.querySelectorAll('.slider-counter--total').length > 0) {
  
    const numberDivs = document.querySelectorAll('.slider-counter--total');

    numberDivs.forEach((div, index) => {
        let number = parseInt(div.textContent, 10); // Get the number in the div
        number = Math.max(0, number - 1); // Subtract 1 from the number, ensuring it doesn't go below 0

        const dotsContainer = document.createElement('div'); // Create a container for dots
        dotsContainer.classList.add('dots-container');

        // Add dot divs based on the updated number
        for (let i = 0; i < number; i++) {
            const dot = document.createElement('div');
            dot.classList.add('dot'); // Create individual dot div
            dotsContainer.appendChild(dot); // Append dot to dots container
        }

        // Find the corresponding .slider-counter.caption div
        const captionDiv = document.querySelectorAll('.slider-counter.caption')[index];
        if (captionDiv) {
            captionDiv.appendChild(dotsContainer); // Append dots container to the caption div
        }
    });

    document.querySelectorAll('.slider-counter .dots-container .dot').forEach(function(dot, index) {
        dot.addEventListener('click', function() {
            // Remove 'active' class from all dots
            document.querySelectorAll('.slider-counter .dots-container .dot').forEach(function(d) {
                d.classList.remove('active');
            });
            // Add 'active' class to the clicked dot
            dot.classList.add('active');
    
            const slider = document.querySelector('.slider.slider--mobile');
            const slides = slider.children;
    
            function goToSlide(index) {
                if (index < slides.length) {
                    const scrollAmount = slides[index].offsetLeft;
                    slider.scrollTo({
                        left: scrollAmount,
                        behavior: 'smooth'
                    });
                }
            }
    
            goToSlide(index);
        });
    });

  document.querySelector('.slider-counter .dots-container .dot').click();

  const cstmSlider = document.querySelector('.slider.slider--mobile');
  const slides = cstmSlider.children;
  let isScrolling;
  
  cstmSlider.addEventListener('scroll', function() {
      
      window.clearTimeout(isScrolling);
  
      isScrolling = setTimeout(function() {
          console.log("Slide scroll completed");
  
          let activeIndex = getActiveSlideIndex();
          console.log("Active Slide Index:", activeIndex);
          document.querySelectorAll('.slider-counter .dots-container .dot')[activeIndex].click();
      }, 100);
  });
  
  function getActiveSlideIndex() {
      const sliderScrollLeft = cstmSlider.scrollLeft;
      let activeIndex = 0;
  
      // Loop through slides to find the active one
      for (let i = 0; i < slides.length; i++) {
          if (sliderScrollLeft < slides[i].offsetLeft + slides[i].offsetWidth / 2) {
              activeIndex = i;
              break;
          }
      }
      return activeIndex;
  }


  
}



  if (window.location.href.match(/page=[2-9]\d*/)) {
    // Add class to the first section
    const section1 = document.querySelectorAll("#MainContent .shopify-section.section")[0]; // Replace '.section1' with the actual class or ID of your section
    if (section1) {
      section1.classList.add("new-class"); // Replace 'new-class' with the class you want to add
    }

    // Add class to the second section
    const section2 = document.querySelectorAll("#MainContent .shopify-section.section")[1]; // Replace '.section2' with the actual class or ID of your section
    if (section2) {
      section2.classList.add("new-class"); // Replace 'new-class' with the class you want to add
    }
  }


  if (document.body.classList.contains('template-product')) {
      const prodDesc = document.querySelector('.prod-desc');
      const productDescription = document.querySelector('.product__description');
   
      if (prodDesc && productDescription) {
  prodDesc.addEventListener('click', () => {
    prodDesc.classList.toggle('active');
    productDescription.classList.toggle('active');
  });
}
  }
    });


$(document).ready(function() {

   $('.cstm_poem_wrapper').slick({
  centerMode: true,
  arrows: true,
  infinite: true,
  dots: true,
  centerPadding: '10px',
  autoplay: false,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  slidesToShow: 1
});


  

    //   const hamburger = document.querySelector('html');
    // const menu = document.querySelector('.menu-drawer-container');

    // menu.addEventListener('click', function() {
    //     hamburger.classList.toggle('active');
    // });





const hamburger = document.querySelector('html');
const menu = document.querySelector('.menu-drawer-container');
const headerDrawerShopArt = document.querySelector('#HeaderDrawer-shop-art');

function toggleActiveClass() {
    hamburger.classList.toggle('active');
}

menu.addEventListener('click', toggleActiveClass);
headerDrawerShopArt.addEventListener('click', toggleActiveClass);





  

            $('.footer-block__heading.inline-richtext').click(function() {
                $(this).next('.footer-block__details-content.list-unstyled').toggleClass('active');
            });
       


  $('.collection_list_new_wrapper').slick({
  centerMode: true,
  arrows: true,
  infinite: true,
  dots: true,
  centerPadding: '10px',
  autoplay: false,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  slidesToShow: 5, // Adjusted this to 4
  responsive: [
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        infinite: true,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1
      }
    }
  ]
});

  if($('body').hasClass('template-index')) {
    document.getElementById('cstm_video').play();
  }

  if($('body').hasClass('template-product')) {
    document.querySelector('.video-section .video-section__poster').click();
  }

  
  
  $('.button').hover(
				
               function () {
                  $(this).addClass('active');
               }, 
				
               function () {
                  $(this).removeClass('active');
               }
            );

    $('#shopify-section-template--21137643831623__logo_list_thCacV .bottom-logo-list').slick({
  centerMode: true,
  arrows: true,
  infinite: true,
  dots: true,
  centerPadding: '10px',
  autoplay: false,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  slidesToShow: 4, // Adjusted this to 4
  responsive: [
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        infinite: true,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1
      }
    }
  ]
});

  

   $('#shopify-section-template--21137643831623__collection_list_Hbm9mc .collection-list').slick({
  centerMode: true,
  arrows:true,
  infinite: true,
  dots:true,
  centerPadding: '10px',
  autoplay: false,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  slidesToShow: 5,
  responsive: [
   
    {
      breakpoint: 480,
      settings: {
        arrows: true,
        infinite: true,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1
      }
    }
  ]
});

  $('html, body').animate({ scrollTop: 0 }, 'slow');

  });



// $(document).ready(function() {
//   setTimeout(function() {
//     var sliderCount = $('.slider-counter--total').text();
//     sliderCount = Number(sliderCount) - 1;
//     $('.slider-counter--total').text(sliderCount);
//   }, 500);
//   $('.slider-button').click(function() {
//     setTimeout(function() {
//       var sliderCount = $('.slider-counter--total').text();
//       sliderCount = Number(sliderCount) - 1;
//       $('.slider-counter--total').text('');
//       $('.slider-counter--total').text(sliderCount);
//     }, 400);
//   });
// });

